<template>
  <v-dialog v-model="dialog" :overlay="false" scrollable max-width="600px">
    <v-card tile flat>
      <v-app-bar flat dark color="primary">
        <v-app-bar-nav-icon><v-icon>far fa-check</v-icon></v-app-bar-nav-icon>
        <v-toolbar-title>Enquiry Accepted</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="closeDialog" dark>
          <v-icon>close</v-icon>
        </v-btn>
      </v-app-bar>
      <v-card flat tile class="ma-0 mb-0">
        <v-card-text>
          <v-form lazy-validation>
            <v-container fluid grid-list-md>
              <v-layout v-if="!showAcceptConfirmation && !showRejectConfirmation">
                <v-btn color="primary" @click="showRejectConfirmation = true">Decline to Offer</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="success" @click="showAcceptConfirmation = true">In Underwriting</v-btn>
              </v-layout>
              <v-layout v-if="showAcceptConfirmation">
                <v-flex xs12>
                  <v-card-title>
                    <h3 class="font-weight-bold">Set enquiry status to 'In Underwriting'?</h3>
                  </v-card-title>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red" text @click.native="showAcceptConfirmation = false">Cancel</v-btn>
                    <v-btn color="success" @click="save('IN UNDERWRITING')">Update</v-btn>
                  </v-card-actions>
                </v-flex>
              </v-layout>
              <v-layout v-if="showRejectConfirmation">
                <v-flex xs12>
                  <v-card-title>
                    <h3 class="font-weight-bold">Are you sure you want to decline your offer?</h3>
                  </v-card-title>
                  <v-card-text>
                    <v-textarea box label="Reason for declining" v-model="rejectionReason"></v-textarea>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red" text @click.native="showRejectConfirmation = false">Cancel</v-btn>
                    <v-btn color="success" @click="save('FUNDER DECLINED TO OFFER')">Decline Offer</v-btn>
                  </v-card-actions>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';

export default {
  name: 'enquiry-accepted-dialog',
  components: {},
  props: ['show', 'enquiry'],
  data: () => ({
    rejectionReason: null,
    showRejectConfirmation: false,
    showAcceptConfirmation: false
  }),
  computed: {
    ...mapGetters(['EnquiryStatuses']),
    dialog: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('update:show', value);
      }
    }
  },
  methods: {
    ...mapActions(['addNotification', 'postCustomerComment', 'storeFunderEnquiry']),
    closeDialog() {
      this.dialog = false;
    },
    async save(statusName) {
      const enquiryStatus = _.find(this.EnquiryStatuses, ['name', statusName]);
      const updates = { enquiry_status_id: enquiryStatus.id };

      if (this.rejectionReason) {
        await this.postCustomerComment({
          comment: this.rejectionReason,
          privacy: 'public',
          commentParams: { id: this.enquiry.id, type: 'enquiry' }
        });
      }

      await this.storeFunderEnquiry({
        id: this.enquiry.id,
        updates
      });

      this.addNotification({ text: `enquiry updated` });
      this.dialog = false;
      this.rejectionReason = null;
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  div.list__tile,
  .subheader {
    padding: 0 16px 0 0;
  }

  input,
  label {
    font-size: 14px;
  }
}

address {
  font-style: normal;
}
</style>
